import React, {useState} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import {getText} from 'helpers/text-helper';
import Button from 'components/ui/button/button';
import './reset-password.scss';

const ResetPassword = ({togglePasswordReset}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [passwordIsReset, setPasswordIsReset] = useState(false);
	const [email, setEmail] = useState('');
	const [feedback, setFeedback] = useState(null);

	/**
	 *  Update input field
	 */
	const handleInput = (event) => {
		setEmail(event.target.value);
		setFeedback(null);
	};

	/** 
	 * Submit reset password request 
	 */
	const handleSubmit = () => {
		if (!email || email.length === 0) {
			setFeedback(getText('errorUiTexts', 'invalidEmail'));
			return;
		}
		handleResetPassword(email);
	};

	/** 
	 * Reset password 
	 */
	const handleResetPassword = (email) => {
		setIsLoading(true);

		const auth = firebase.auth();
		auth.sendPasswordResetEmail(email).then(()=>{
			setIsLoading(false);
			setPasswordIsReset(true);
		}).catch((error) =>{
			console.error(error);
			setIsLoading(false);
			setFeedback(getText('errorUiTexts', 'unknownError'));
		});
	};

	if (passwordIsReset) {
		return (
			<div className="ResetPassword">
				<div className="ResetPassword-wrap">
					<div className="ResetPassword-title">
						<span>{getText('loginUiTexts', 'facilitatorResetPw')}</span>
					</div>
					<div className="ResetPassword-info">
						<span>{getText('loginUiTexts', 'passwordIsReset')}</span>
					</div>
					<div 
						className="ResetPassword-resetPasswordBtn"
						onClick={()=>{togglePasswordReset();}}
					>
						<span>{getText('loginUiTexts', 'backToLogin')}</span>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="ResetPassword">
			<div className="ResetPassword-wrap">
				<div className="ResetPassword-title"><span>{getText('loginUiTexts', 'facilitatorResetPw')}</span></div>
				<form className="ResetPassword-form" onSubmit={handleSubmit}>
					<input
						name="email"
						type="text"
						placeholder={getText('loginUiTexts', 'email')}
						autoComplete="section-resetpasswrd email"
						value={email ? email : ''}
						onChange={(event)=>{handleInput(event);}}
					/>
					<div className="ResetPassword-resetPasswordBtn">
						<Button
							isLoading={isLoading}
							classes={['facilitator']}
							text={getText('loginUiTexts', 'reset')}
							onClick={() =>{handleSubmit();}}
						/>
					</div>
					<div className="ResetPassword-errorMessage">
						<span>{feedback}</span>
					</div>
				</form>
				<div 
					className="ResetPassword-backToLogin"
					onClick={()=>{togglePasswordReset();}}
				><span>{getText('loginUiTexts', 'backToLogin')}</span></div>
			</div>
		</div>
	);
};

ResetPassword.propTypes = {
	togglePasswordReset: PropTypes.func.isRequired,
};

export default ResetPassword;